//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// export default {
//   props: {
//     ifAddEdit: {
//       type: Boolean,
//       default: false
//     }
//   },
//   data() {
//     return {
//        interfaceForm: {
//         sysName: [],
//         roleNum: null,
//         roleName: [],
//         type: null,
//         desc: null,
//         status: null
//       },
//       rules: {
//         type: [
//           { required: true, message: '请选择资源类型', trigger: 'change' }
//         ],
//         num: [
//           { required: true, message: '请输入资源编号', trigger: 'blur' },
//         ],
//         name: [
//           { required: true, message: '请输入资源名称', trigger: 'blur' },
//         ],
//         sysName: [
//           { required: true, message: '请选择系统名称', trigger: 'change' }
//         ],
//       },
//     }
//   },
//   methods: {
//     cancelDailog(){
//       this.$emit('menuSubmit', { bool: false})
//     },
//     commit(formName){
//        this.$refs[formName].validate((valid) => {
//         if (valid) {
//           this.$emit('menuSubmit', { bool: true, formData: this.interfaceForm})
//         } else {
//           console.log('error submit!!');
//           return false;
//         }
//       });
//     }
//   }
// }
//